export const DATA = [
  {
    title: 'Meet Wilson, our AI-powered assistant',
    subtitle:
      'Any questions? Ask our AI-powered assistant Wilson — he’ll provide helpful suggestions right in the editor.',
    videoUrl:
      'https://superhi-editor.s3.us-east-1.amazonaws.com/videos/editor-more-features/01_wilson.mp4',
  },
  {
    title: 'Practical, visual tools',
    subtitle:
      'We’ve reimagined the coding experience for creatives with image previewing, a visual color picker, friendly UI and more.',
    videoUrl:
      'https://superhi-editor.s3.us-east-1.amazonaws.com/videos/editor-more-features/02_color-picker.mp4',
  },
  {
    title: 'Simple custom domain and SSL setup',
    subtitle:
      'Why not have a .party URL? You can add custom domains to any project, and make them secure with SSL too.',
    videoUrl:
      'https://superhi-editor.s3.us-east-1.amazonaws.com/videos/editor-more-features/03_custom-domain.mp4',
  },

  {
    title: 'Say goodbye to typos',
    subtitle:
      'Our editor points out errors as soon as you type them, so you can quickly figure out where and how your code went wrong. Practice makes perfect!',
    videoUrl:
      'https://superhi-editor.s3.us-east-1.amazonaws.com/videos/editor-more-features/04_highlight-errors.mp4',
  },
  {
    title: 'Code suggestions as you type',
    subtitle:
      'Easy input for dozens of HTML elements and CSS properties, with explanations of each one.',
    videoUrl:
      'https://superhi-editor.s3.us-east-1.amazonaws.com/videos/editor-more-features/05_html-css.mp4',
  },
  {
    title: 'Autosave and built-in version control',
    subtitle:
      'Never worry about losing your code again! You can create new versions, view and revert to previous versions of your projects.',
    videoUrl:
      'https://superhi-editor.s3.us-east-1.amazonaws.com/videos/editor-more-features/06_version-control.mp4',
  },
]
